import type { DefaultTranslationsObject, Language } from '../types.js'

export const deTranslations: DefaultTranslationsObject = {
  authentication: {
    account: 'Benutzerkonto',
    accountOfCurrentUser: 'Aktuelles Benutzerkonto',
    accountVerified: 'Benutzerkonto erfolgreich verifiziert.',
    alreadyActivated: 'Bereits aktiviert',
    alreadyLoggedIn: 'Bereits angemeldet',
    apiKey: 'API-Schlüssel',
    authenticated: 'Authentifiziert',
    backToLogin: 'Zurück zur Anmeldung',
    beginCreateFirstUser: 'Erstelle ein erstes Benutzerkonto, um zu beginnen',
    changePassword: 'Passwort ändern',
    checkYourEmailForPasswordReset:
      'Wenn die E-Mail-Adresse mit einem Benutzerkonto verknüpft ist, erhältst du in Kürze Anweisungen zum Zurücksetzen deines Passworts. Bitte überprüfe auch deinen Spam-Ordner, falls du die E-Mail nicht im Posteingang siehst.',
    confirmGeneration: 'Generierung bestätigen',
    confirmPassword: 'Passwort bestätigen',
    createFirstUser: 'Erstes Benutzerkonto erstellen',
    emailNotValid: 'Die angegebene E-Mail-Adresse ist ungültig.',
    emailOrUsername: 'E-Mail oder Benutzername',
    emailSent: 'E-Mail versendet',
    emailVerified: 'E-Mail erfolgreich verifiziert.',
    enableAPIKey: 'API-Schlüssel aktivieren',
    failedToUnlock: 'Entsperrung fehlgeschlagen',
    forceUnlock: 'Entsperrung erzwingen',
    forgotPassword: 'Passwort vergessen',
    forgotPasswordEmailInstructions:
      'Bitte gib deine E-Mail-Adresse an. Du wirst eine E-Mail mit Instruktionen zum Zurücksetzen deines Passworts erhalten.',
    forgotPasswordQuestion: 'Passwort vergessen?',
    forgotPasswordUsernameInstructions:
      'Bitte gib deinen Benutzernamen ein. Anweisungen zum Zurücksetzen deines Passworts werden an die mit deinem Benutzernamen verknüpfte E-Mail-Adresse gesendet.',
    generate: 'Generieren',
    generateNewAPIKey: 'Neuen API-Schlüssel generieren',
    generatingNewAPIKeyWillInvalidate:
      'Wenn du einen neuen API-Schlüssel generierst, wird der vorherige <1>ungültig</1>. Bist du sicher, dass du fortfahren möchtest?',
    lockUntil: 'Gesperrt bis',
    logBackIn: 'Wieder anmelden',
    loggedIn:
      'Um dich mit einem anderen Benutzerkonto anzumelden, musst du dich zuerst <0>abmelden</0>.',
    loggedInChangePassword:
      'Um dein Passwort zu ändern, gehe zu deinem <0>Benutzerkonto</0> und ändere dort dein Passwort.',
    loggedOutInactivity: 'Du wurdest aufgrund von Inaktivität abgemeldet.',
    loggedOutSuccessfully: 'Du wurdest erfolgreich abgemeldet.',
    loggingOut: 'Abmelden...',
    login: 'Anmelden',
    loginAttempts: 'Anmeldeversuche',
    loginUser: 'Benutzer anmelden',
    loginWithAnotherUser:
      'Um dich mit einem anderen Benutzer anzumelden, musst du dich zuerst <0>abmelden</0>.',
    logOut: 'Abmelden',
    logout: 'Abmeldung',
    logoutSuccessful: 'Abmeldung erfolgreich.',
    logoutUser: 'Benutzer abmelden',
    newAccountCreated:
      'Ein neues Konto wurde auf <a href="{{serverURL}}">{{serverURL}}</a> für dich erstellt. Bitte klicke auf den folgenden Link oder kopiere die URL in deinen Browser, um deine E-Mail-Adresse zu verifizieren: <a href="{{verificationURL}}">{{verificationURL}}</a><br> Nachdem du deine E-Mail-Adresse verifiziert hast, kannst du dich anmelden.',
    newAPIKeyGenerated: 'Neuer API-Schlüssel wurde generiert',
    newPassword: 'Neues Passwort',
    passed: 'Authentifizierung erfolgreich',
    passwordResetSuccessfully: 'Passwort erfolgreich zurückgesetzt.',
    resend: 'Erneut senden',
    resetPassword: 'Passwort zurücksetzen',
    resetPasswordExpiration: 'Passwort-Gültigkeitsdauer zurücksetzen',
    resetPasswordToken: 'Passwort-Token zurücksetzen',
    resetYourPassword: 'Dein Passwort zurücksetzen',
    stayLoggedIn: 'Angemeldet bleiben',
    successfullyRegisteredFirstUser: 'Ersten Benutzer erfolgreich registriert.',
    successfullyUnlocked: 'Erfolgreich entsperrt',
    tokenRefreshSuccessful: 'Token-Aktualisierung erfolgreich.',
    unableToVerify: 'Konnte nicht verifiziert werden',
    username: 'Benutzername',
    usernameNotValid: 'Der angegebene Benutzername ist nicht gültig.',
    verified: 'Verifiziert',
    verifiedSuccessfully: 'Erfolgreich verifiziert',
    verify: 'Verifizieren',
    verifyUser: 'Benutzer verifizieren',
    verifyYourEmail: 'Deine E-Mail-Adresse verifizieren',
    youAreInactive:
      'Du warst einige Zeit inaktiv und wirst in Kürze zu deiner eigenen Sicherheit abgemeldet. Möchtest du angemeldet bleiben?',
    youAreReceivingResetPassword:
      'Du erhältst diese Nachricht, weil du (oder jemand anderes) das Zurücksetzen deines Passworts für dein Benutzerkonto angefordert hat. Bitte klicke auf den folgenden Link, oder kopiere die URL in deinen Browser, um den Prozess abzuschließen:',
    youDidNotRequestPassword:
      'Solltest du dies nicht angefordert haben, ignoriere diese E-Mail. Dein Passwort bleibt unverändert.',
  },
  dashboard: {
    addButton: 'Hinzufügen +',
    addWidget: 'Widget hinzufügen',
    deleteWidget: 'Widget {{id}} löschen',
    discardConfirmLabel: 'Verwerfen',
    discardMessage:
      'Du hast ungespeicherte Änderungen an deinem Dashboard-Layout. Bist du sicher, dass du diese verwerfen möchtest?',
    discardTitle: 'Änderungen verwerfen?',
    editDashboard: 'Dashboard bearbeiten',
    editingDashboard: 'Dashboard bearbeiten',
    noItems:
      'Auf deinem Dashboard befinden sich keine Widgets. Du kannst diese über das "Dashboard"-Menü in der oberen Leiste hinzufügen.',
    resetLayout: 'Layout zurücksetzen',
    searchWidgets: 'Suche Widgets...',
  },
  error: {
    accountAlreadyActivated: 'Dieses Benutzerkonto wurde bereits aktiviert',
    autosaving: 'Es gab ein Problem bei der automatischen Speicherung für dieses Dokument',
    correctInvalidFields: 'Bitte ungültige Felder korrigieren.',
    deletingFile: 'Beim Löschen der Datei ist ein Fehler aufgetreten.',
    deletingTitle:
      'Es gab ein Problem während der Löschung von {{title}}. Bitte überprüfe deine Verbindung und versuche es erneut.',
    documentNotFound:
      'Das Dokument mit der ID {{id}} konnte nicht gefunden werden. Es könnte gelöscht, niemals existiert haben oder du hast keinen Zugriff darauf.',
    emailOrPasswordIncorrect: 'Die E-Mail-Adresse oder das Passwort sind nicht korrekt.',
    failedToResetLayout: 'Layout konnte nicht zurückgesetzt werden.',
    failedToSaveLayout: 'Layout konnte nicht gespeichert werden.',
    followingFieldsInvalid_one: 'Das folgende Feld ist nicht korrekt:',
    followingFieldsInvalid_other: 'Die folgenden Felder sind nicht korrekt:',
    incorrectCollection: 'Falsche Sammlung',
    insufficientClipboardPermissions:
      'Zugriff auf die Zwischenablage verweigert. Bitte überprüfe die Berechtigungen.',
    invalidClipboardData: 'Ungültige Zwischenablagedaten.',
    invalidFileType: 'Ungültiger Datei-Typ',
    invalidFileTypeValue: 'Ungültiger Datei-Typ: {{value}}',
    invalidRequestArgs: 'Ungültige Argumente in der Anfrage: {{args}}',
    loadingDocument: 'Es gab ein Problem, das Dokument mit der ID {{id}} zu laden.',
    localesNotSaved_one: 'Die folgende Sprache konnte nicht gespeichert werden:',
    localesNotSaved_other: 'Die folgenden Sprachen konnten nicht gespeichert werden:',
    logoutFailed: 'Abmeldung fehlgeschlagen.',
    missingEmail: 'E-Mail-Adresse fehlt.',
    missingIDOfDocument: 'ID des zu speichernden Dokuments fehlt.',
    missingIDOfVersion: 'ID der Version fehlt.',
    missingRequiredData: 'Erforderliche Daten fehlen.',
    noFilesUploaded: 'Es wurden keine Dateien hochgeladen.',
    noMatchedField: 'Kein übereinstimmendes Feld für "{{label}}" gefunden',
    notAllowedToAccessPage: 'Du hast keine Berechtigung, auf diese Seite zuzugreifen.',
    notAllowedToPerformAction: 'Du hast keine Berechtigung, diese Aktion auszuführen.',
    notFound: 'Die angeforderte Ressource wurde nicht gefunden.',
    noUser: 'Kein Benutzer',
    previewing: 'Bei der Vorschau dieses Dokuments ist ein Fehler aufgetreten.',
    problemUploadingFile: 'Beim Hochladen der Datei ist ein Fehler aufgetreten.',
    restoringTitle:
      'Es gab einen Fehler beim Wiederherstellen von {{title}}. Bitte überprüfe die Verbindung und versuche es erneut.',
    revertingDocument: 'Es gab ein Problem beim Zurücksetzen dieses Dokuments.',
    tokenInvalidOrExpired: 'Token ist entweder ungültig oder abgelaufen.',
    tokenNotProvided: 'Token nicht bereitgestellt.',
    unableToCopy: 'Kopieren nicht möglich.',
    unableToDeleteCount: '{{count}} von {{total}} {{label}} konnten nicht gelöscht werden.',
    unableToReindexCollection:
      'Fehler beim Neuindizieren der Sammlung {{collection}}. Vorgang abgebrochen.',
    unableToUpdateCount: '{{count}} von {{total}} {{label}} konnten nicht aktualisiert werden.',
    unauthorized: 'Nicht autorisiert - du musst angemeldet sein, um diese Anfrage zu stellen.',
    unauthorizedAdmin: 'Nicht autorisiert, dieser Benutzer hat keinen Zugriff auf das Admin-Panel.',
    unknown: 'Ein unbekannter Fehler ist aufgetreten.',
    unPublishingDocument:
      'Bei der Aufhebung der Veröffentlichung dieses Dokuments ist ein Fehler aufgetreten.',
    unspecific: 'Ein Fehler ist aufgetreten.',
    unverifiedEmail: 'Bitte verifiziere deine E-Mail, bevor du dich anmeldest.',
    userEmailAlreadyRegistered: 'Ein Benutzer mit der angegebenen E-Mail ist bereits registriert.',
    userLocked:
      'Dieser Benutzer ist gesperrt, weil er zu viele fehlgeschlagene Anmeldeversuche hat.',
    usernameAlreadyRegistered:
      'Ein Benutzer mit dem angegebenen Benutzernamen ist bereits registriert.',
    usernameOrPasswordIncorrect: 'Der angegebene Benutzername oder das Passwort ist falsch.',
    valueMustBeUnique: 'Wert muss einzigartig sein',
    verificationTokenInvalid: 'Verifizierungs-Token ist nicht korrekt.',
  },
  fields: {
    addLabel: '{{label}} hinzufügen',
    addLink: 'Link hinzufügen',
    addNew: 'Neuen Eintrag hinzufügen',
    addNewLabel: '{{label}} erstellen',
    addRelationship: 'Verknüpfung hinzufügen',
    addUpload: 'Neue Datei hochladen',
    block: 'Block',
    blocks: 'Blöcke',
    blockType: 'Block-Typ',
    chooseBetweenCustomTextOrDocument:
      'Wähle zwischen der Eingabe einer benutzerdefinierten URL oder verknüpfe ein anderes Dokument.',
    chooseDocumentToLink: 'Wähle ein Dokument, das du verlinken möchtest',
    chooseFromExisting: 'Aus vorhandenen auswählen',
    chooseLabel: '{{label}} auswählen',
    collapseAll: 'Alle einklappen',
    customURL: 'Eigene URL',
    editLabelData: '{{label}} bearbeiten',
    editLink: 'Link bearbeiten',
    editRelationship: 'Verknüpfung bearbeiten',
    enterURL: 'URL eingeben',
    internalLink: 'Interne Verlinkung',
    itemsAndMore: '{{items}} und {{count}} mehr',
    labelRelationship: '{{label}}-Verknüpfung',
    latitude: 'Breitengrad',
    linkedTo: 'Verweist auf <0>{{label}}</0>',
    linkType: 'Linktyp',
    longitude: 'Längengrad',
    newLabel: '{{label}} erstellen',
    openInNewTab: 'In neuem Tab öffnen',
    passwordsDoNotMatch: 'Passwörter stimmen nicht überein.',
    relatedDocument: 'Verknüpftes Dokument',
    relationTo: 'Verknüpfung zu',
    removeRelationship: 'Verknüpfung entfernen',
    removeUpload: 'Hochgeladene Datei löschen',
    saveChanges: 'Änderungen speichern',
    searchForBlock: 'Nach Block suchen',
    searchForLanguage: 'Nach Sprache suchen',
    selectExistingLabel: '{{label}} auswählen (vorhanden)',
    selectFieldsToEdit: 'Zu bearbeitende Felder auswählen',
    showAll: 'Alle anzeigen',
    swapRelationship: 'Verknüpfung tauschen',
    swapUpload: 'Datei austauschen',
    textToDisplay: 'Angezeigter Text',
    toggleBlock: 'Block umschalten',
    uploadNewLabel: '{{label}} neu hochladen',
  },
  folder: {
    browseByFolder: 'Nach Ordner durchsuchen',
    byFolder: 'Nach Ordner',
    deleteFolder: 'Ordner löschen',
    folderName: 'Ordnername',
    folders: 'Ordner',
    folderTypeDescription:
      'Wähle aus, welche Art von Sammlungsdokumenten in diesem Ordner zugelassen sein sollen.',
    itemHasBeenMoved: '{{title}} wurde in {{folderName}} verschoben.',
    itemHasBeenMovedToRoot: '{{title}} wurde in den Hauptordner verschoben.',
    itemsMovedToFolder: '{{title}} Elemente wurden in {{folderName}} verschoben.',
    itemsMovedToRoot: '{{title}} Elemente wurden in den Hauptordner verschoben.',
    moveFolder: 'Ordner verschieben',
    moveItemsToFolderConfirmation:
      'Du bist dabei, <1>{{count}} {{label}}</1> nach <2>{{toFolder}}</2> zu verschieben. Bist du dir sicher?',
    moveItemsToRootConfirmation:
      'Du bist dabei, <1>{{count}} {{label}}</1> in den Hauptordner zu verschieben. Bist du dir sicher?',
    moveItemToFolderConfirmation:
      'Du bist dabei, <1>{{title}}</1> zu <2>{{toFolder}}</2> zu verschieben. Bist du dir sicher?',
    moveItemToRootConfirmation:
      'Du bist dabei, <1>{{title}}</1> in den Hauptordner zu verschieben. Bist du dir sicher?',
    movingFromFolder: 'Verschieben von {{title}} aus {{fromFolder}}',
    newFolder: 'Neuer Ordner',
    noFolder: 'Kein Ordner',
    renameFolder: 'Ordner umbenennen',
    searchByNameInFolder: 'Nach Namen in {{folderName}} suchen',
    selectFolderForItem: 'Ordner für {{title}} auswählen',
  },
  general: {
    name: 'Name',
    aboutToDelete: 'Du bist dabei, {{label}} <1>{{title}}</1> zu löschen. Bist du dir sicher?',
    aboutToDeleteCount_many: 'Du bist dabei, {{count}} {{label}} zu löschen.',
    aboutToDeleteCount_one: 'Du bist dabei, {{count}} {{label}} zu löschen.',
    aboutToDeleteCount_other: 'Du bist dabei, {{count}} {{label}} zu löschen.',
    aboutToPermanentlyDelete:
      'Du bist dabei, das {{label}} <1>{{title}}</1> dauerhaft zu löschen. Bist du dir sicher?',
    aboutToPermanentlyDeleteTrash:
      'Du bist dabei, <0>{{count}}</0> <1>{{label}}</1> endgültig aus dem Papierkorb zu löschen. Bist du dir sicher?',
    aboutToRestore:
      'Du bist dabei, das {{label}} <1>{{title}}</1> wiederherzustellen. Bist du dir sicher?',
    aboutToRestoreAsDraft:
      'Du bist dabei, das {{label}} <1>{{title}}</1> als Entwurf wiederherzustellen. Bist du dir sicher?',
    aboutToRestoreAsDraftCount:
      'Du bist dabei, {{count}} {{label}} als Entwurf wiederherzustellen.',
    aboutToRestoreCount: 'Du bist dabei, {{count}} {{label}} wiederherzustellen.',
    aboutToTrash:
      'Du bist dabei, das {{label}} <1>{{title}}</1> in den Papierkorb zu verschieben. Bist du dir sicher?',
    aboutToTrashCount: 'Du bist dabei, {{count}} {{label}} in den Papierkorb zu verschieben.',
    addBelow: 'Unterhalb hinzufügen',
    addFilter: 'Filter hinzufügen',
    adminTheme: 'Admin-Erscheinungsbild',
    all: 'Alle',
    allCollections: 'Alle Sammlungen',
    allLocales: 'Alle Sprachen',
    and: 'Und',
    anotherUser: 'Ein anderer Benutzer',
    anotherUserTakenOver: 'Ein anderer Benutzer hat die Bearbeitung dieses Dokuments übernommen.',
    applyChanges: 'Änderungen anwenden',
    ascending: 'Aufsteigend',
    automatic: 'Automatisch',
    backToDashboard: 'Zurück zur Übersicht',
    cancel: 'Abbrechen',
    changesNotSaved:
      'Deine Änderungen wurden nicht gespeichert. Wenn du diese Seite verlässt, gehen deine Änderungen verloren.',
    clear: 'Leeren',
    clearAll: 'Alles leeren',
    close: 'Schließen',
    collapse: 'Einklappen',
    collections: 'Sammlungen',
    columns: 'Spalten',
    columnToSort: 'Spalte zum Sortieren',
    confirm: 'Bestätigen',
    confirmCopy: 'Kopie bestätigen',
    confirmDeletion: 'Löschung bestätigen',
    confirmDuplication: 'Duplizieren bestätigen',
    confirmMove: 'Verschiebung bestätigen',
    confirmReindex: 'Alle {{collections}} neu indizieren?',
    confirmReindexAll: 'Alle Sammlungen neu indizieren?',
    confirmReindexDescription:
      'Dies entfernt bestehende Indizes und indiziert die Dokumente in den {{collections}}-Sammlungen neu.',
    confirmReindexDescriptionAll:
      'Dies entfernt bestehende Indizes und indiziert die Dokumente in allen Sammlungen neu.',
    confirmRestoration: 'Wiederherstellung bestätigen',
    copied: 'Kopiert',
    copy: 'Kopieren',
    copyField: 'Feld kopieren',
    copying: 'Kopieren',
    copyRow: 'Zeile kopieren',
    copyWarning:
      'Du bist dabei, {{to}} mit {{from}} für {{label}} {{title}} zu überschreiben. Bist du dir sicher?',
    create: 'Erstellen',
    created: 'Erstellt',
    createdAt: 'Erstellt am',
    createNew: 'Neu erstellen',
    createNewLabel: '{{label}} neu erstellen',
    creating: 'Erstelle',
    creatingNewLabel: 'Erstelle {{label}}',
    currentlyEditing:
      'bearbeitet gerade dieses Dokument. Wenn du übernimmst, wird die Bearbeitung blockiert und nicht gespeicherte Änderungen können verloren gehen.',
    custom: 'Benutzerdefiniert',
    dark: 'Dunkel',
    dashboard: 'Übersicht',
    delete: 'Löschen',
    deleted: 'Gelöscht',
    deletedAt: 'Gelöscht am',
    deletedCountSuccessfully: '{{count}} {{label}} erfolgreich gelöscht.',
    deletedSuccessfully: 'Erfolgreich gelöscht.',
    deleteLabel: '{{label}} löschen',
    deletePermanently: 'Papierkorb überspringen und dauerhaft löschen',
    deleting: 'Löschen...',
    depth: 'Tiefe',
    descending: 'Absteigend',
    deselectAllRows: 'Alle Zeilen abwählen',
    document: 'Dokument',
    documentIsTrashed: 'Dieses {{label}} wurde gelöscht und ist nur lesbar.',
    documentLocked: 'Dokument gesperrt',
    documentModified: 'Dokument geändert',
    documentOutOfDate:
      'Dieses Dokument wurde kürzlich von einem anderen Benutzer aktualisiert. Deine Ansicht ist veraltet.',
    documents: 'Dokumente',
    duplicate: 'Duplizieren',
    duplicateWithoutSaving: 'Duplizieren ohne Änderungen zu speichern',
    edit: 'Bearbeiten',
    editAll: 'Alle bearbeiten',
    editedSince: 'Bearbeitet seit',
    editing: 'Bearbeiten',
    editingLabel_many: 'Bearbeiten von {{count}} {{label}}',
    editingLabel_one: 'Bearbeiten von {{count}} {{label}}',
    editingLabel_other: 'Bearbeiten von {{count}} {{label}}',
    editingTakenOver: 'Bearbeitung übernommen',
    editLabel: '{{label}} bearbeiten',
    email: 'E-Mail',
    emailAddress: 'E-Mail-Adresse',
    emptyTrash: 'Papierkorb leeren',
    emptyTrashLabel: '{{label}} Papierkorb leeren',
    enterAValue: 'Gib einen Wert ein',
    error: 'Fehler',
    errors: 'Fehler',
    exitLivePreview: 'Live-Vorschau beenden',
    export: 'Export',
    fallbackToDefaultLocale: 'Auf die Standardsprache zurückfallen',
    false: 'Falsch',
    filter: 'Filter',
    filters: 'Filter',
    filterWhere: 'Filter {{label}}, wo',
    globals: 'Globale Dokumente',
    goBack: 'Zurück',
    groupByLabel: 'Nach {{label}} gruppieren',
    import: 'Importieren',
    isEditing: 'bearbeitet gerade',
    item: 'Element',
    items: 'Elemente',
    language: 'Sprache',
    lastModified: 'Zuletzt geändert',
    layout: 'Layout',
    leaveAnyway: 'Trotzdem verlassen',
    leaveWithoutSaving: 'Ohne Speichern verlassen',
    light: 'Hell',
    livePreview: 'Live-Vorschau',
    loading: 'Lädt',
    locale: 'Sprache',
    locales: 'Sprachen',
    lock: 'Sperren',
    menu: 'Menü',
    moreOptions: 'Mehr Optionen',
    move: 'Verschieben',
    moveConfirm:
      'Du bist dabei, {{count}} {{label}} nach <1>{{destination}}</1> zu verschieben. Bist du dir sicher?',
    moveCount: '{{count}} {{label}} verschieben',
    moveDown: 'Nach unten verschieben',
    moveUp: 'Nach oben verschieben',
    moving: 'Verschieben',
    movingCount: '{{count}} {{label}} verschieben',
    newLabel: 'Neu {{label}}',
    newPassword: 'Neues Passwort',
    next: 'Nächste',
    no: 'Nein',
    noDateSelected: 'Kein Datum ausgewählt',
    noFiltersSet: 'Keine Filter gesetzt',
    noLabel: '<Kein {{label}}>',
    none: 'Kein',
    noOptions: 'Keine Optionen',
    noResults:
      'Keine {{label}} gefunden. Entweder existieren keine {{label}} oder es gibt keine Übereinstimmung mit den angewendeten Filtern.',
    noResultsDescription:
      'Es existieren keine oder keine entsprechen den oben angegebenen Filtern.',
    noResultsFound: 'Keine Ergebnisse gefunden.',
    notFound: 'Nicht gefunden',
    nothingFound: 'Keine Ergebnisse',
    noTrashResults: 'Kein {{label}} im Papierkorb.',
    noUpcomingEventsScheduled: 'Keine bevorstehenden Ereignisse geplant.',
    noValue: 'Kein Wert',
    of: 'von',
    only: 'Nur',
    open: 'Öffnen',
    openInNewWindow: 'In neuem Fenster öffnen',
    or: 'oder',
    order: 'Reihenfolge',
    overwriteExistingData: 'Vorhandene Eingaben überschreiben',
    pageNotFound: 'Seite nicht gefunden',
    password: 'Passwort',
    pasteField: 'Feld einfügen',
    pasteRow: 'Zeile einfügen',
    payloadSettings: 'Payload-Einstellungen',
    permanentlyDelete: 'Dauerhaft löschen',
    permanentlyDeletedCountSuccessfully: '{{count}} {{label}} erfolgreich dauerhaft gelöscht.',
    perPage: 'Pro Seite: {{limit}}',
    previous: 'Vorherige',
    reindex: 'Neuindizieren',
    reindexingAll: 'Alle {{collections}} werden neu indiziert.',
    reloadDocument: 'Dokument neu laden',
    remove: 'Entfernen',
    rename: 'Umbenennen',
    reset: 'Zurücksetzen',
    resetPreferences: 'Präferenzen zurücksetzen',
    resetPreferencesDescription: 'Alle Präferenzen werden auf die Standardwerte zurückgesetzt.',
    resettingPreferences: 'Präferenzen werden zurückgesetzt.',
    restore: 'Wiederherstellen',
    restoreAsPublished: 'Wiederherstellen als veröffentlichte Version',
    restoredCountSuccessfully: '{{count}} {{label}} erfolgreich wiederhergestellt.',
    restoring: 'Wiederherstellen...',
    row: 'Zeile',
    rows: 'Zeilen',
    save: 'Speichern',
    saveChanges: 'Änderungen speichern',
    saving: 'Speichern...',
    schedulePublishFor: 'Veröffentlichung für {{title}} planen',
    searchBy: 'Suche nach {{label}}',
    select: 'Auswählen',
    selectAll: 'Alle {{count}} {{label}} auswählen',
    selectAllRows: 'Alle Zeilen auswählen',
    selectedCount: '{{count}} {{label}} ausgewählt',
    selectLabel: '{{label}} auswählen',
    selectValue: 'Wert auswählen',
    showAllLabel: 'Alle {{label}} anzeigen',
    sorryNotFound:
      'Es tut uns leid, aber wir haben nichts gefunden, was deiner Anfrage entspricht.',
    sort: 'Sortieren',
    sortByLabelDirection: 'Sortieren nach {{label}} {{direction}}',
    stayOnThisPage: 'Auf dieser Seite bleiben',
    submissionSuccessful: 'Übermittlung erfolgreich.',
    submit: 'Senden',
    submitting: 'Senden...',
    success: 'Erfolg',
    successfullyCreated: '{{label}} erfolgreich erstellt.',
    successfullyDuplicated: '{{label}} wurde erfolgreich dupliziert.',
    successfullyReindexed:
      '{{count}} von insgesamt {{total}} Dokumenten aus {{collections}} wurden erfolgreich neu indexiert, {{skips}} Entwürfe wurden übersprungen.',
    takeOver: 'Übernehmen',
    thisLanguage: 'Deutsch',
    time: 'Zeit',
    timezone: 'Zeitzone',
    titleDeleted: '{{label}} {{title}} wurde erfolgreich gelöscht.',
    titleRestored: '{{label}} "{{title}}" erfolgreich wiederhergestellt.',
    titleTrashed: '{{label}} "{{title}}" wurde in den Papierkorb verschoben.',
    trash: 'Papierkorb',
    trashedCountSuccessfully: '{{count}} {{label}} wurde in den Papierkorb verschoben.',
    true: 'Wahr',
    unauthorized: 'Nicht autorisiert',
    unlock: 'Entsperren',
    unsavedChanges:
      'Du hast ungespeicherte Änderungen. Speichere oder verwerfe sie, bevor du fortfährst.',
    unsavedChangesDuplicate:
      'Du hast ungespeicherte Änderungen. Möchtest du mit dem Duplizieren fortfahren?',
    untitled: 'Ohne Titel',
    upcomingEvents: 'Bevorstehende Ereignisse',
    updatedAt: 'Aktualisiert am',
    updatedCountSuccessfully: '{{count}} {{label}} erfolgreich aktualisiert.',
    updatedLabelSuccessfully: '{{label}} erfolgreich aktualisiert.',
    updatedSuccessfully: 'Erfolgreich aktualisiert.',
    updateForEveryone: 'Für alle aktualisieren',
    updating: 'Aktualisieren',
    uploading: 'Hochladen',
    uploadingBulk: 'Hochladen von {{current}} von {{total}}',
    user: 'Benutzer',
    username: 'Benutzername',
    users: 'Benutzer',
    value: 'Wert',
    viewing: 'Ansehen',
    viewReadOnly: 'Nur-Lese-Ansicht',
    welcome: 'Willkommen',
    yes: 'Ja',
  },
  localization: {
    cannotCopySameLocale: 'Kann nicht in dieselbe Sprache kopiert werden',
    copyFrom: 'Kopieren von',
    copyFromTo: 'Kopieren von {{from}} nach {{to}}',
    copyTo: 'Kopieren nach',
    copyToLocale: 'In Sprachvariante kopieren',
    localeToPublish: 'Zu veröffentlichende Sprache',
    selectedLocales: 'Ausgewählte Sprachen',
    selectLocaleToCopy: 'Sprache zum Kopieren auswählen',
    selectLocaleToDuplicate: 'Sprachen zum Duplizieren auswählen',
  },
  operators: {
    contains: 'enthält',
    equals: 'gleich',
    exists: 'existiert',
    intersects: 'überschneidet sich',
    isGreaterThan: 'ist größer als',
    isGreaterThanOrEqualTo: 'ist größer oder gleich',
    isIn: 'ist in',
    isLessThan: 'ist kleiner als',
    isLessThanOrEqualTo: 'ist kleiner oder gleich',
    isLike: 'ist wie',
    isNotEqualTo: 'ist nicht gleich',
    isNotIn: 'ist nicht in',
    isNotLike: 'ist nicht wie',
    near: 'in der Nähe',
    within: 'innerhalb',
  },
  upload: {
    addFile: 'Datei hinzufügen',
    addFiles: 'Dateien hinzufügen',
    bulkUpload: 'Mehrere Dateien hochladen',
    crop: 'Zuschneiden',
    cropToolDescription:
      'Ziehe die Ecken des ausgewählten Bereichs, zeichne einen neuen Bereich oder passe die Werte unten an.',
    download: 'Herunterladen',
    dragAndDrop: 'Datei per Drag & Drop verschieben',
    dragAndDropHere: 'oder Datei hier ablegen',
    editImage: 'Bild bearbeiten',
    fileName: 'Dateiname',
    fileSize: 'Dateigröße',
    filesToUpload: 'Dateien zum Hochladen',
    fileToUpload: 'Datei zum Hochladen',
    focalPoint: 'Fokuspunkt',
    focalPointDescription:
      'Setze den Fokuspunkt direkt auf der Vorschau oder passe die Werte unten an.',
    height: 'Höhe',
    lessInfo: 'Weniger Info',
    moreInfo: 'Mehr Info',
    noFile: 'Keine Datei',
    pasteURL: 'URL einfügen',
    previewSizes: 'Bildgrößen anzeigen',
    selectCollectionToBrowse: 'Eine Sammlung zum Durchsuchen auswählen',
    selectFile: 'Datei auswählen',
    setCropArea: 'Zuschneide-Bereich festlegen',
    setFocalPoint: 'Fokuspunkt setzen',
    sizes: 'Bildgrößen',
    sizesFor: 'Bildgrößen für {{label}}',
    width: 'Breite',
  },
  validation: {
    emailAddress: 'Bitte gib eine korrekte E-Mail-Adresse an.',
    enterNumber: 'Bitte gib eine gültige Nummer an.',
    fieldHasNo: 'Dieses Feld hat kein {{label}}',
    greaterThanMax: '{{value}} ist größer als der maximal erlaubte {{label}} von {{max}}.',
    invalidBlock: 'Der Block "{{block}}" ist nicht erlaubt.',
    invalidBlocks: 'Dieses Feld enthält Blöcke, die nicht mehr erlaubt sind: {{blocks}}.',
    invalidInput: 'Dieses Feld hat einen inkorrekten Wert.',
    invalidSelection: 'Dieses Feld hat eine inkorrekte Auswahl.',
    invalidSelections: 'Dieses Feld enthält die folgenden inkorrekten Auswahlmöglichkeiten:',
    latitudeOutOfBounds: 'Die Breitengrade müssen zwischen -90 und 90 liegen.',
    lessThanMin: '{{value}} ist kleiner als der minimal erlaubte {{label}} von {{min}}.',
    limitReached: 'Limit erreicht, es können nur {{max}} Elemente hinzugefügt werden.',
    longerThanMin: 'Dieser Wert muss länger als die minimale Länge von {{minLength}} Zeichen sein.',
    longitudeOutOfBounds: 'Die Längengrad muss zwischen -180 und 180 liegen.',
    notValidDate: '"{{value}}" ist kein gültiges Datum.',
    required: 'Pflichtfeld',
    requiresAtLeast: 'Dieses Feld muss mindestens {{count}} {{label}} enthalten.',
    requiresNoMoreThan: 'Dieses Feld darf nicht mehr als {{count}} {{label}} enthalten.',
    requiresTwoNumbers: 'Dieses Feld muss zwei Zahlen enthalten.',
    shorterThanMax:
      'Dieser Wert muss kürzer als die maximale Länge von {{maxLength}} Zeichen sein.',
    timezoneRequired: 'Eine Zeitzone ist erforderlich.',
    trueOrFalse: 'Dieses Feld kann nur wahr oder falsch sein.',
    username:
      'Bitte gib einen gültigen Benutzernamen ein. Dieser kann Buchstaben, Zahlen, Bindestriche, Punkte und Unterstriche enthalten.',
    validUploadID: 'Dieses Feld enthält keine gültige Upload-ID.',
  },
  version: {
    type: 'Typ',
    aboutToPublishSelection:
      'Du bist dabei, alle {{label}} in der Auswahl zu veröffentlichen. Bist du dir sicher?',
    aboutToRestore: 'Du bist dabei, {{label}} auf den Stand vom {{versionDate}} zurückzusetzen.',
    aboutToRestoreGlobal:
      'Du bist dabei, das globale Dokument {{label}} auf den Stand vom {{versionDate}} zurückzusetzen.',
    aboutToRevertToPublished:
      'Du bist dabei, dieses Dokument auf den Stand des ersten Veröffentlichungsdatums zurückzusetzen. Bist du sicher?',
    aboutToUnpublish: 'Du bist dabei, dieses Dokument auf Entwurf zu setzen. Bist du dir sicher?',
    aboutToUnpublishIn:
      'Du bist dabei, dieses Dokument in {{locale}} zu entpublizieren. Bist du dir sicher?',
    aboutToUnpublishSelection:
      'Du bist dabei, die Veröffentlichung aller {{label}} in der Auswahl aufzuheben. Bist du sicher?',
    autosave: 'Automatische Speicherung',
    autosavedSuccessfully: 'Automatisch gespeichert.',
    autosavedVersion: 'Automatisch gespeicherte Version',
    changed: 'Geändert',
    changedFieldsCount_one: '{{count}} geändertes Feld',
    changedFieldsCount_other: '{{count}} geänderte Felder',
    compareVersion: 'Version vergleichen mit:',
    compareVersions: 'Versionen vergleichen',
    comparingAgainst: 'Im Vergleich zu',
    confirmPublish: 'Veröffentlichung bestätigen',
    confirmRevertToSaved: 'Zurücksetzen auf die letzte Speicherung bestätigen',
    confirmUnpublish: 'Aufhebung der Veröffentlichung bestätigen',
    confirmVersionRestoration: 'Wiederherstellung der Version bestätigen',
    currentDocumentStatus: 'Aktueller Dokumentenstatus: {{docStatus}}',
    currentDraft: 'Aktueller Entwurf',
    currentlyPublished: 'Derzeit veröffentlicht',
    currentlyViewing: 'Derzeitige Ansicht',
    currentPublishedVersion: 'Aktuell veröffentlichte Version',
    draft: 'Entwurf',
    draftHasPublishedVersion: 'Entwurf (hat veröffentlichte Version)',
    draftSavedSuccessfully: 'Entwurf erfolgreich gespeichert.',
    lastSavedAgo: 'Zuletzt vor {{distance}} gespeichert',
    modifiedOnly: 'Nur modifiziert',
    moreVersions: 'Mehr Versionen...',
    noFurtherVersionsFound: 'Keine weiteren Versionen vorhanden',
    noLabelGroup: 'Unbenannte Gruppe',
    noRowsFound: 'Kein {{label}} gefunden',
    noRowsSelected: 'Kein {{label}} ausgewählt',
    preview: 'Vorschau',
    previouslyDraft: 'Früherer Entwurf',
    previouslyPublished: 'Zuvor veröffentlicht',
    previousVersion: 'Frühere Version',
    problemRestoringVersion: 'Beim Wiederherstellen der Version ist ein Fehler aufgetreten',
    publish: 'Veröffentlichen',
    publishAllLocales: 'Alle Sprachen veröffentlichen',
    publishChanges: 'Änderungen veröffentlichen',
    published: 'Veröffentlicht',
    publishIn: 'Veröffentlichen auf {{locale}}',
    publishing: 'Veröffentlichung',
    restoreAsDraft: 'Als Entwurf wiederherstellen',
    restoredSuccessfully: 'Erfolgreich wiederhergestellt.',
    restoreThisVersion: 'Diese Version wiederherstellen',
    restoring: 'Wiederherstellen...',
    reverting: 'Zurücksetzen...',
    revertToPublished: 'Auf veröffentlichte Version zurücksetzen',
    revertUnsuccessful:
      'Zurücksetzen fehlgeschlagen. Keine zuvor veröffentlichte Version gefunden.',
    saveDraft: 'Entwurf speichern',
    scheduledSuccessfully: 'Erfolgreich geplant.',
    schedulePublish: 'Veröffentlichungsplanung',
    selectLocales: 'Anzuzeigende Sprachen auswählen',
    selectVersionToCompare: 'Zu vergleichende Version auswählen',
    showingVersionsFor: 'Versionen anzeigen für:',
    showLocales: 'Sprachen anzeigen:',
    specificVersion: 'Spezifische Version',
    status: 'Status',
    unpublish: 'Veröffentlichung aufheben',
    unpublished: 'Unveröffentlicht',
    unpublishedSuccessfully: 'Erfolgreich unveröffentlicht.',
    unpublishIn: 'Unveröffentlichen in {{locale}}',
    unpublishing: 'Veröffentlichung aufheben...',
    version: 'Version',
    versionAgo: 'vor {{distance}}',
    versionCount_many: '{{count}} Versionen gefunden',
    versionCount_none: 'Keine Versionen gefunden',
    versionCount_one: '{{count}} Version gefunden',
    versionCount_other: '{{count}} Versionen gefunden',
    versionID: 'Versions-ID',
    versions: 'Versionen',
    viewingVersion: 'Version für {{entityLabel}} {{documentTitle}} ansehen',
    viewingVersionGlobal: 'Version für das globale Dokument {{entityLabel}} ansehen',
    viewingVersions: 'Versionen für {{entityLabel}} {{documentTitle}} ansehen',
    viewingVersionsGlobal: 'Versionen für das globale Dokument {{entityLabel}} ansehen',
  },
}

export const de: Language = {
  dateFNSKey: 'de',
  translations: deTranslations,
}
